import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {isApiResponseOk} from '../../util/utils';

export function deficiencymetricsreducer(state = initialstate.deficiencymetrics, action) {
	if (action.type !== types.GET_DEFICIENCY_METRICS) {
		return state;
	}

	if (!isApiResponseOk(action)) {
		return state;
	}

	return action.response;
}
